// Mapping used to transform shipping address fields between
// form data and vendor address payload structure.
export const VENDOR_SHIPPING_ADDRESS_TYPE = "shipping";

export const VENDOR_SHIPPING_ADDRESS_FIELDS = {
  street: "addressLine1",
  aptSte: "addressLine2",
  city: "city",
  state: "state",
  country: "country",
  zipcode: "zipcode",
} as const;

// Labels used for shipping address validation and UI error messages.
export const VENDOR_SHIPPING_ADDRESS_LABELS = {
  addressLine1: "Shipping Address Street",
  addressLine2: "Shipping Address (Apt/Ste)",
  city: "Shipping Address City",
  state: "Shipping Address State",
  country: "Shipping Address Country",
  zipcode: "Shipping Address Zip Code",
} as const;